import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=94c993e0"
import script from "./RichText.vue?vue&type=script&lang=ts"
export * from "./RichText.vue?vue&type=script&lang=ts"
import style0 from "quill/dist/quill.snow.css?vue&type=style&index=0&lang=css"
import style1 from "./RichText.vue?vue&type=style&index=1&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports